<template>
  <span class="yxtbiz-certificate-preview hand" @click="preview">
    <yxt-image
      ref="imgPreview"
      class="yxtbiz-certificate-preview__previewer"
      :src="previewUrl"
      :preview-src-list="[previewUrl]"
      fit="contain">
    </yxt-image>
    <slot></slot>
  </span>
</template>

<script>
import {
  Image as YxtImage
} from 'yxt-pc';
import { getCer } from './service';
export default {
  name: 'YxtbizCertificatePreview',
  components: {
    YxtImage
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpened: false,
      previewUrl: '',
      cer: {}
    };
  },
  methods: {
    initCerInfo() {
      getCer(this.id).then((res) => {
        this.cer = res;
        if (this.isOpened) {
          this.preview();
        }
      });
    },
    preview() {
      this.isOpened = false;
      if (this.cer.type === 0) {
        this.previewUrl = this.cer.coverUrl;
      } else {
        this.previewUrl = this.cer.customCoverUrl;
      }
      if (!this.previewUrl) {
        this.isOpened = !!this.id;
        return;
      }
      this.$nextTick(() => {
        this.$refs.imgPreview && this.$refs.imgPreview.clickHandler();
      });
    }
  },
  watch: {
    id: {
      handler() {
        this.initCerInfo();
      },
      immediate: true
    }
  }
};
</script>
